<template>
  <div>
    <div v-if="list.length > 0">
      <span :key="item.key" v-for="item in list">{{ item.key }}={{ item.value }}% </span>
    </div>
    <span v-else>список пуст</span>
    <button type="button" @click="openEdit">Редактировать</button>

    <modal name="edit" @before-close="beforeClose" :adaptive="true" :resizable="true" height="auto" class="modal">
      <div class="modal-content">
        <table>
          <thead>
          <tr>
            <th>Страна (ISO Alpha 2)</th>
            <th>Дискреп (%)</th>
            <th>#</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="item.key" v-for="item in list">
            <td><input type="text" v-model="item.key" /></td>
            <td><input type="text" v-model="item.value" min="0" max="100"></td>
            <td>
              <button type="button" @click="deleteKey(item.key)">Удалить</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="modal-actions">
          <button type="button" @click="addRow()">Новая страна</button>
          <button type="button" @click="hide()">Закрыть</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    // value is JSON map
    value: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    openEdit() {
      this.$modal.show('edit');
    },
    deleteKey(key) {
      this.list = this.list.filter(item => item.key !== key);
    },
    addRow() {
      if (this.list.find(item => item.key === '')) {
        return;
      }
      this.list.push({
        key: '',
        value: 10,
      });
    },
    apply() {
      const map = {};
      this.list.forEach(item => {
        map[item.key] = parseInt(item.value, 10);
      });
      this.$emit('input', map);
    },
    hide() {
      this.$modal.hide('edit');
    },
    beforeClose() {
      this.apply();
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        const list = [];
        for (let i in value) {
          list.push({
            key: i,
            value: value[i],
          });
        }
        this.list = list;
      },
    },
  },
};
</script>

<style>
.modal-content {
  padding: 20px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
}
</style>
